import { NgModule }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { ShareContainerComponent }     from './share-container/share-container.component';
import { ShareButtonComponent }     from './share-button/share-button.component';


@NgModule({
  imports:      [ CommonModule, FormsModule ],
  declarations: [ ShareContainerComponent, ShareButtonComponent ],
  exports:      [ ShareContainerComponent ]
})
export class ShareModule { }



// WEBPACK FOOTER //
// C:/Users/Yi-Yu/Documents/Actual Documents/Katiso/katiso/node_modules/ng2share/share.module.ts